<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <!-- <template #cell(dadefinire)="item">
                            <span> {{ item.dadefinire || "da-definire" }}</span>
                        </template> -->
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Configurazione" variant="outline-secondary" @click="onClickViewConfigurazioneFornitori(item)">
                                    <font-awesome-icon icon="eye"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Configurazione" variant="outline-success" @click="onClickEditConfigurazioneFornitori(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella Configurazione" variant="outline-danger" @click="onClickDeleteConfigurazioneFornitore(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
                <configurazioni-magazzino-fornitori-modal-edit-component ref="cmpConfigurazioniFornitoriModalEdit" @saveFornitore="loadDataFornitori" @fornitoreDelete="loadDataFornitori" @onCloseModal="loadDataFornitori" />
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioniMagazzinoFornitoriModalEditComponent from "./ConfigurazioniMagazzinoFornitoriModalEditComponent.vue";
export default {
    name: "ConfigurazioneMagazzinoFornitoriListComponent",
    components: { ConfigurazioniMagazzinoFornitoriModalEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            id: null,
            currentPage: 1,
            pathResource: "/magazzinofornitori",
            showModalLoading: false,
            listKey: 0,
            items: [],
            filtroConfigurazioniFornitori: { codiceAzienda: null, um: null },
            fields: [
                {
                    label: "*",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 1rem",
                },
                {
                    label: "Ragione Sociale",
                    key: "ragioneSocialeFornitore",
                    sortable: false,
                },
                {
                    label: "Codice Fornitore",
                    key: "codiceFornitore",
                    sortable: false,
                },
                {
                    label: "Partita Iva",
                    key: "partitaIvaFornitore",
                    sortable: false,
                },
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadDataFornitori();
        },
    },
    methods: {
        // ==================== CRUD ====================
        loadDataFornitori() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroConfigurazioniFornitori"]) {
                me.filtroConfigurazioniFornitori = JSON.parse(sessionStorage["filtroConfigurazioniFornitori"]);
                me.$emit("updateFilter", me.filtroConfigurazioniFornitori);
            }
            me.filtroConfigurazioniFornitori.page = me.currentPage;
            me.filtroConfigurazioniFornitori.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroConfigurazioniFornitori, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.$emit("afterLoadData");
        },
        // ==================== UTILITY ====================
        onClickViewConfigurazioneFornitori(item) {
            let me = this;
            me.$refs.cmpConfigurazioniFornitoriModalEdit.show(item, true);
        },
        onClickEditConfigurazioneFornitori(item) {
            let me = this;
            me.$refs.cmpConfigurazioniFornitoriModalEdit.show(item, false);
        },
        onNuovoFornitore() {
            let me = this;
            me.$refs.cmpConfigurazioniFornitoriModalEdit.show(
                {
                    id: null,
                    ragioneSocialeFornitore: null,
                    partitaIvaFornitore: null,
                    capFornitore: null,
                    indirizzoFornitore: null,
                    provinciaFornitore: null,
                    localitaFornitore: null,
                    telefonoFornitore: null,
                    emailFornitore: null,
                    codiceFornitore: null,
                    note: null,
                },
                false
            );
        },
        onClickDeleteConfigurazioneFornitore(item) {
            let me = this;
            me.$refs.cmpConfigurazioniFornitoriModalEdit.onDeleteFornitore(item);
        },
    },
};
</script>
